import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Order from './views/order/order.vue'
import orderReceived from './views/order/orderReceived.vue'
import orderDetails from './views/order/orderDetails.vue'
import myContract from './views/contract/index.vue'
import contractInfo from './views/contract/contractInfo.vue'
import budget from './views/budget/index.vue'
import budgetInfo from './views/budget/budgetInfo.vue'
import adContract from './views/contract/adContract.vue'
import appointment from './views/appointment/index.vue'
import viewPdfsyz from './views/viewPdfsyz.vue'
import viewHandwriting from './views/appointment/viewHandwriting.vue'
import contractList from './views/appointment/list.vue'
import packagesList from './views/packages/index.vue'
import packagesComplete from './views/packages/packagesComplete.vue'

import packagesDetail from './views/packages/packagesDetail.vue'
import myList from './views/appointment/myList.vue'
import receipt from './views/appointment/receipt.vue'
import viewPdfs from './views/appointment/viewPdfs.vue'
// import viewPdfs from '@/components/pdfs.vue'
import contractStatus from './views/appointment/contractStatus.vue'
import make from './views/make/index.vue'
import login from './views/login/index.vue'
import info from './views/manInfo/info.vue'
import activityList from './views/activity/index.vue'
import activeInfo from './views/activity/activeInfo.vue'
import adActive from './views/activity/adActive.vue'
import salesroom from './views/salesroom/index.vue'
import InvoiceNumber from './views/InvoiceNumber'
import exhibition from './views/exhibition/index.vue'
import adviser from './views/adviser/index.vue'
import service from './views/service/index.vue'
import servicedetail from './views/service/servicedetail.vue'


Vue.use(Router)

export default new Router({
  // mode: 'history',
  history:true,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:{
        title: '我的' 
      }
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta:{
        title: '全部订单' 
      }
    },
    {
      path: '/service',
      name: 'service',
      component: service,
      meta:{
        title: '待签服务单' 
      }
    },    
    
    {
      path: '/orderReceived',
      name: 'orderReceived',
      component: orderReceived,
      meta:{
        title: '待收货' 
      }
    },
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: orderDetails,
      meta:{
        title: '订单详情' 
      }
    },
    {
      path: '/myContract',
      name: 'myContract',
      component: myContract,
      meta:{
        title: '我的报修' 
      }
    },
    {
      path: '/contractInfo',
      name: 'contractInfo',
      component: contractInfo,
      meta:{
        title: '保修详情' 
      }
    },
    {
      path: '/budget',
      name: 'budget',
      component: budget,
      meta:{
        title: '我的预算' 
      }
    },
    {
      path: '/budgetInfo',
      name: 'budgetInfo',
      component: budgetInfo,
      meta:{
        title: '预算详情' 
      }
    },
    {
      path: '/adContract',
      name: 'adContract',
      component: adContract,
      meta:{
        title: '新增报修' 
      }
    },
    {
      path: '/appointment',
      name: 'appointment',
      component: appointment,
      meta:{
        title: '签订合同' 
      }
    },
    {
      path: '/contractList',
      name: 'contractList',
      component: contractList,
      meta:{
        title: '合同列表' 
      }
    },
    {
      path: '/packagesList',
      name: 'packagesList',
      component: packagesList,
      meta:{
        title: '补贴套餐付款' 
      }
    },
    {
      path: '/packagesComplete',
      name: 'packagesComplete',
      component: packagesComplete,
      meta:{
        title: '补贴套餐付款查询' 
      }
    },
    {
      path: '/packagesDetail',
      name: 'packagesDetail',
      component: packagesDetail,
      meta:{
        title: '补贴套餐' 
      }
    },
    

    
    {
      path: '/myList',
      name: 'myList',
      component: myList,
      meta:{
        title: '我的合同' 
      }
    },
    {
      path: '/receipt',
      name: 'receipt',
      component: receipt,
      meta:{
        title: '我的收据' 
      }
    },    
    {
      path: '/make',
      name: 'make',
      component: make,
      meta:{
        title: '我的预约' 
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title: '绑定手机号' 
      }
    },
    {
      path: '/servicedetail',
      name: 'servicedetail',
      component: servicedetail,
      meta:{
        title: '签订服务单' 
      }
    },    
    
    {
      path: '/info',
      name: 'info',
      component: info,
      meta:{
        title: '个人信息' 
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: activityList,
      meta:{
        title: '活动' 
      }
    },
    {
      path: '/activeInfo',
      name: 'activeInfo',
      component: activeInfo,
      meta:{
        title: '活动详情' 
      }
    },
    {
      path: '/adActive',
      name: 'adActive',
      component: adActive,
      meta:{
        title: '0元设计' 
      }
    },
    {
      path: '/salesroom',
      name: 'salesroom',
      component: salesroom,
      meta:{
        title: '周边门店' 
      }
    },
    {
      path: '/InvoiceNumber',
      name: 'InvoiceNumber',
      component: InvoiceNumber,
      meta:{
        title: '发票申请' 
      }
    },
    {
      path: '/viewPdfs',
      name: 'viewPdfs',
      component: viewPdfs,
      meta:{
        title: '查看详情' 
      }
    },
    {
      path: '/viewPdfsyz',
      name: 'viewPdfsyz',
      component: viewPdfsyz,
      meta:{
        title: '详情' 
      }
    },
    
    {
      path: '/exhibition',
      name: 'exhibition',
      component: exhibition,
      meta:{
        title: '关于梵华' 
      }
    },
    {
      path: '/adviser',
      name: 'adviser',
      component: adviser,
      meta:{
        title: '私人顾问' 
      }
    },
    {
      path: '/viewHandwriting',
      name: 'viewHandwriting',
      component: viewHandwriting,
      meta:{
        title: '确认签名' 
      }
    },
    {
      path: '/contractStatus',
      name: 'contractStatus',
      component: contractStatus,
      meta:{
        title: '合同状态' 
      }
    },
  ]
})
